/* Added the following code for POW-798.Dharma using AI Agent. April 1, 2026. Code Start */
import React from 'react';

const ManagePromptsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/upload/manageprompts',
			component: React.lazy(() => import('./ManagePrompts'))
		}
	]
};

export default ManagePromptsConfig;
/* Code end. Dharma using AI Agent. April 1, 2026 */
